import {MilestoneIcon} from '@primer/octicons-react'
import {Link, ProgressBar} from '@primer/react'
import {SkeletonText} from '@primer/react/experimental'

import {useMilestoneQuery} from './data/route-queries'
import sidebarListStyles from './SidebarActionList.module.css'
import styles from './Milestone.module.css'

export function Milestone() {
  const {data, isPending, isError} = useMilestoneQuery()
  if (isPending) return <SkeletonMilestone />
  if (isError) return <span className={sidebarListStyles.emptyState}>Unable to load milestone</span>

  const milestone = data?.milestone
  if (!milestone) return <span className={sidebarListStyles.emptyState}>No milestone</span>

  return (
    <div className={styles.milestone}>
      <ProgressBar
        barSize="small"
        progress={milestone.progressPercentage}
        aria-label={`${Math.round(milestone.progressPercentage)}% complete`}
      />
      <div className={styles.header}>
        <Link href={milestone.url} className={styles.titleLink} muted>
          <MilestoneIcon className={styles.titleIcon} />
          {milestone.title}
        </Link>
        {milestone.closed && <span className={styles.closedBadge}>Closed</span>}
      </div>
    </div>
  )
}

function SkeletonMilestone() {
  return (
    <>
      <span className="sr-only">Loading...</span>
      <SkeletonText width="10ch" />
    </>
  )
}
